import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
import { JourneyTimeline } from './JourneyTimeline';
import { Heart, Film, BarChart3, Monitor } from 'lucide-react';
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    x: -20
  },
  show: {
    opacity: 1,
    x: 0
  }
};
export function SlidePostCongress() {
  const [imgError, setImgError] = useState(false);
  return <div className="h-full w-full bg-[#EDF4F8] text-[#1B4F72] p-8 md:p-12 flex flex-col" data-id="element-445">
      <JourneyTimeline currentStage={5} data-id="element-446" />

      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-6 border-l-4 border-[#3D6B8E] pl-6" data-id="element-447">
        <div className="flex items-center gap-3 mb-2" data-id="element-448">
          <span className="text-4xl" data-id="element-449">🔁</span>
          <h2 className="text-3xl font-bold text-[#1B4F72]" data-id="element-450">Post Congress</h2>
        </div>
        <p className="text-xl text-[#3D6B8E] font-medium" data-id="element-451">
          Goal: Keep momentum & move prospects further down funnel
        </p>
      </motion.div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-[1fr_auto] gap-8 min-h-0" data-id="element-452">
        {/* Left Column: Tactics + Features stacked */}
        <div className="flex flex-col gap-5 overflow-auto" data-id="element-453">
          <motion.div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100" variants={container} initial="hidden" animate="show" data-id="element-454">
            <h3 className="text-lg font-bold text-[#1B4F72] mb-4 flex items-center gap-2" data-id="element-455">
              <span className="w-8 h-1 bg-[#3D6B8E] rounded-full" data-id="element-456"></span>
              Tactics
            </h3>
            <ul className="space-y-3" data-id="element-457">
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-458">
                <Heart className="w-5 h-5 text-[#3D6B8E] mt-0.5 shrink-0" data-id="element-459" />
                <span className="text-gray-700 text-sm" data-id="element-460">
                  "Thank you" Snak™ with recap & highlights
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-461">
                <Film className="w-5 h-5 text-[#3D6B8E] mt-0.5 shrink-0" data-id="element-462" />
                <span className="text-gray-700 text-sm" data-id="element-463">
                  Personalized "what you missed" reels
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-464">
                <BarChart3 className="w-5 h-5 text-[#3D6B8E] mt-0.5 shrink-0" data-id="element-465" />
                <span className="text-gray-700 text-sm" data-id="element-466">
                  Polls or surveys to learn what resonated
                </span>
              </motion.li>
            </ul>
          </motion.div>

          <motion.div className="bg-[#3D6B8E]/5 p-5 rounded-xl border border-[#3D6B8E]/10" variants={container} initial="hidden" animate="show" data-id="element-467">
            <h3 className="text-lg font-bold text-[#1B4F72] mb-4 flex items-center gap-2" data-id="element-468">
              <span className="w-8 h-1 bg-[#7CB9D8] rounded-full" data-id="element-469"></span>
              Snakker™ Features
            </h3>
            <ul className="space-y-3" data-id="element-470">
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-471">
                <div className="w-2 h-2 rounded-full bg-[#7CB9D8] mt-1.5 shrink-0" data-id="element-472" />
                <span className="text-gray-700 text-sm" data-id="element-473">
                  <strong className="text-[#1B4F72]" data-id="element-474">Rating Cue™</strong> for
                  session feedback
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-475">
                <div className="w-2 h-2 rounded-full bg-[#7CB9D8] mt-1.5 shrink-0" data-id="element-476" />
                <span className="text-gray-700 text-sm" data-id="element-477">
                  <strong className="text-[#1B4F72]" data-id="element-478">Goto Cue™</strong> to
                  navigate between topics
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-479">
                <div className="w-2 h-2 rounded-full bg-[#7CB9D8] mt-1.5 shrink-0" data-id="element-480" />
                <span className="text-gray-700 text-sm" data-id="element-481">
                  Output reports to support{' '}
                  <strong className="text-[#1B4F72]" data-id="element-482">CRM follow-up</strong>
                </span>
              </motion.li>
            </ul>
          </motion.div>
        </div>

        {/* Right Column: Example Screenshot */}
        <motion.div className="flex flex-col items-center justify-center" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-483">
          <div className="rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-gray-100 max-w-[220px]" data-id="element-484">
            {imgError ? <div className="flex flex-col items-center justify-center w-full h-48 text-gray-400 p-4" data-id="element-485">
                <Monitor className="w-10 h-10 mb-2 text-[#3D6B8E]/40" data-id="element-486" />
                <p className="text-xs" data-id="element-487">Image not available</p>
              </div> : <img src="https://cdn.magicpatterns.com/uploads/hKQRrCwFdu6HMrKkMijaTP/Screenshot_2026-02-11_at_19.14.35.png" alt="Post-congress thank you Snak™ — Dr. Azmain video message" className="w-full h-auto object-contain" onError={() => setImgError(true)} data-id="element-488" />}
          </div>
          <motion.p className="mt-2 text-[10px] text-[#5B8FAF] italic text-center max-w-[220px]" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.6
        }} data-id="element-489">
            Example: Video thank-you Snak™
          </motion.p>
        </motion.div>
      </div>
    </div>;
}